import { FC, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useNetworkPointByUuid } from 'src/apis/monolith/use-network-point-by-uuid';
import { PageSpinner } from 'src/components/spinner-container';

export const NetworkPointsRedirect: FC = () => {
  const { networkPointId } = useParams<{ networkPointId: string }>();
  const { push } = useHistory();
  const oldNetworkPoint = useNetworkPointByUuid(networkPointId);

  useEffect(() => {
    if (!oldNetworkPoint.response) return;
    push(
      `/platform/#/network-point/details/${oldNetworkPoint.response.data.id}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oldNetworkPoint.response]);

  return <PageSpinner />;
};
